<template>
<a class="item" @click="showProductDetails()">

  <i v-if="wdtype=='lostBuybox' && item.statusDetails && item.statusDetails.message && item.statusDetails.message.indexOf('no offers from any sellers') >= 0 " :class="'right grey warning circle big icon'"></i>
  <i v-else :class="'right '+(item.issueStatus > 0 && (item.status==1||item.status==2) ? 'blue' :itemprops.listcolor[item.status])+' '+itemprops.listicon+' big icon'"></i>

  <div v-show="item.date !== null" class="ui basic top right attached label">
    {{ (new Date(item.date)).toLocaleDateString('en-US') }}
    <div class="detail">
      {{ (new Date(item.date)).toLocaleTimeString('en-US') }}
    </div>
  </div>
  <div class="content">

    <!-- Lazy loaded image -->
    <img v-if="detSel=='wd' && item.productId!==null && imageLoaded"
         :src="$parent.$parent.$parent.worldStore.products[item.productId].largeImageUrl"
         style="max-width:110px;max-height:110px;width:auto;height:auto;border-radius:2px;"
         class="left floated small ui image"/>

    <!-- Placeholder -->
    <div v-else-if="detSel=='wd' && item.productId!==null"
         class="left floated small ui image"
         style="width:110px;height:110px;background:#f5f5f5;border-radius:2px;display:flex;align-items:center;justify-content:center;">
      <i class="grey image icon"></i>
    </div>

    <div v-if="item.productId !== null || item.productGroupId !== null || item.marketplace !== null" class="ui left floated basic segment description" style="width:19%; max-height:113px; padding:0; margin:0; overflow:hidden;
    text-overflow:clip;">
      <span v-if="item.productId!==null || item.productGroupId!==null">
        <i :class="getMarketplaceFlag(item)"></i>
        <span
          v-if="groupByParent && item.productGroupProductIds && item.productGroupProductIds.length>1"
          class="ui mini circular grey label"
          style="padding-top: .8em !important; min-height: 1em; line-height: .5em; margin-right: 4px;"
          :data-content="item.productGroupProductIds.length+' variations in this group'" data-position="top left" data-variation="mini">
          {{item.productGroupProductIds.length}}
        </span>
        {{ getProductTitle(item.productId) }}
      </span>
      <div v-else-if="item.marketplace && item.sellerId && $parent.$parent.$parent.worldStore.sellerAccounts[item.sellerId]" style="padding-top:6px">{{$parent.$parent.$parent.worldStore.sellerAccounts[item.sellerId].accountNickName}} - {{item.marketplace}} marketplace</div>
    </div>

    <div class="ui right floated basic segment header" v-bind:style="'width:' + (item.productId !== null ? '58' : '80') + '%; padding:0; margin:0; font-size:16px;'">

      <img v-if="wdtype=='salesDrop'"
          @click.stop.prevent="$parent.$parent.$parent.$refs.chartModal.open($parent.$parent.$parent.worldStore.products[item.productId], null)"
          :src="'/api/sentinel/watchdog/salesdropchart/'+item.watchDogId"
          class="right floated small ui image"/>

      <span><i v-if="item.muted" class="blue mute alarm outline icon"></i></span>
      <span v-if="(item.status === 1 || item.status === 2)&&!item.muted">
        <span v-if="item.issueStatus == 1" class="ui tiny circular blue label" style="margin-left:0;margin-right:5px;"><i class="ui inverted blue unhide icon" style="margin-right:3px;"></i>Seen</span>
        <span v-else-if="item.issueStatus == 2" class="ui tiny circular blue label" style="margin-left:0;margin-right:5px;"><i class="ui inverted blue time  icon" style="margin-right:3px;"></i>In Progress</span>
        <span v-else-if="item.issueStatus == 3" class="ui tiny circular blue label" style="margin-left:0;margin-right:5px;"><i class="ui inverted blue check icon" style="margin-right:3px;"></i>Done</span>
      </span>


      <span v-if="wdtype=='badReview' || wdtype=='topReview'" v-html="prettyfyReviewText(item.statusDetails.message)"></span>
      <span v-else-if="wdtype=='starRatingRecentChange'"      v-html="prettyfyRatingText(item.statusDetails.message)"></span>
      <span v-else v-text="item.statusDetails.message"></span>


      <div class="description issueStatusButton" v-if="wdtype!='listingSuspended'" style="margin-top:35px; position:relative;">

        <a class="ui tiny orange basic compact icon button" style="margin-left:0;" v-if="item.productId!==null&&wdtype!='badReview'&&wdtype!='topReview'" target="_blank" :href="$parent.$parent.$parent.worldStore.products[item.productId].productUrl" @click.stop><i class='icon external share'></i>View on Amazon</a>
        <a class="ui tiny orange basic compact icon button" style="margin-left:0;" v-else-if="item.productId!==null&&wdtype=='badReview'" target="_blank" :href="$parent.$parent.$parent.worldStore.products[item.productId].productReviewsUrl" @click.stop><i class='icon external share'></i>Latest Reviews</a>
        <a class="ui tiny orange basic compact icon button" style="margin-left:0;" v-else-if="item.productId!==null&&wdtype=='topReview'" target="_blank" :href="$parent.$parent.$parent.worldStore.products[item.productId].productTopReviewsUrl" @click.stop><i class='icon external share'></i> Top Rated Reviews</a>
        <a class="ui tiny orange basic compact icon button" style="margin-left:0;" v-else-if="wdtype=='badSellerFeedback'" target="_blank" :href="$parent.$parent.$parent.worldStore.sellerAccounts[item.sellerId].feedbackUrls[item.marketplace]" @click.stop><i class='icon external share'></i>View on Amazon</a>
        <span></span>
       &nbsp;&nbsp;&nbsp;

        <!-- Issue status -->
        <span v-if="(item.status === 1 || item.status === 2)&&!item.muted" class="issueStatusButton" style="position:absolute; top:-20px; font-size:11px">
          <i class="grey book icon" style="margin-right:1px;"></i>Issue Status
          <!-- <small>set by <input style="width:35px;"/></small> -->
        </span>
        <div class="ui tiny basic blue compact buttons issueStatusButton" @click.stop.prevent
             v-if="(item.status === 1 || item.status === 2)&&!item.muted">
          <div v-if="item.issueStatus==0" class="ui button" @click="setIssueStatus(1)">Mark as Seen</div>
          <div v-if="item.issueStatus==1" class="ui button" @click="setIssueStatus(2)">Mark as In Progress</div>
          <div v-if="item.issueStatus==2" class="ui button" @click="setIssueStatus(3)">Mark as Done</div>
          <div v-if="item.issueStatus==3" class="ui disabled button" >Mark as &#10132;</div>
          <div class="ui top right pointing dropdown icon button">
            <i class="dropdown icon"></i>
            <div class="small menu">
              <div class="header" style="margin-top: 9px;">Mark issue as ...</div>
              <div v-if="item.issueStatus!=0" @click="setIssueStatus(0)" class="item"><i class="hide icon"></i> New</div>
              <div v-if="item.issueStatus!=1" @click="setIssueStatus(1)" class="item"><i class="unhide icon"></i> Seen</div>
              <div v-if="item.issueStatus!=2" @click="setIssueStatus(2)" class="item"><i class="time icon"></i> In Progress</div>
              <div v-if="item.issueStatus!=3" @click="setIssueStatus(3)" class="item"><i class="check icon"></i> Done</div>
            </div>
          </div>
        </div>
        &nbsp;&nbsp;

        <!-- mute -->
        <div v-if="!item.muted" class="ui tiny basic compact button issueStatusButton" @click.stop.prevent>
          <div class="ui top right pointing dropdown">
          <span
            :data-html="'Mute this alert type' + ($parent.accountLevelWd ? '' : ('<br>for this product ' + (groupByParent && item.productGroupProductIds && item.productGroupProductIds.length>1 ? 'and variations' : '')))"
            data-variation="mini"
            data-position="right center">
            {{$parent.accountLevelWd ? 'Mute' : 'Mute Product...'}}
          </span>
            <div class="small menu">
              <div class="header" style="margin-top: 9px;">Mute for ...</div>
              <div class="item" @click="muteItem(60*24)"   >24h</div>
              <div class="item" @click="muteItem(60*24*3)" >3 days</div>
              <div class="item" @click="muteItem(60*24*7)" >1 week</div>
              <div class="item" @click="muteItem(60*24*14)">2 weeks</div>
              <div class="item" @click="muteItem(60*24*30)">1 month</div>
              <div class="item" @click="muteItem(60*24*61)">2 months</div>
              <div class="item" @click="muteItem(60*24*999)">Until I turn it back on</div>
            </div>
          </div>
        </div>
        <a v-if="item.muted" href="" @click.stop.prevent="muteItem(-1)" class="ui tiny basic label">Un-mute</a>

        <div v-if="$parent.$parent.$parent.onboarding.issuestatus && itemtype==='red'" class="onboarding ui up pointing large yellow label" style="margin: 10px 0 0 40px;" data-onboarding="issuestatus" @click.stop.prevent>
          Mark as Seen - This is very useful!<br/>
          <small style="float:left;margin-top: 5px;">Click [Mark as Seen] to dismiss these notes</small>
        </div>

      </div>
    </div>

  </div>
</a>
</template>

<script>
import $ from 'jquery'
export default {
  data: function () {
    return {
      imageLoaded: false
    }
  },
  props: ['item', 'itemtype', 'itemprops', 'wdtype', 'groupByParent', 'detSel'],
  methods: {
    muteItem: function (m) {
      if (this.itemtype !== 'mute') {
        $(this.$el).fadeOut(600, () => {
          this.$emit('muteRingAni')
          this.item.muted = !this.item.muted
        })
      } else {
        this.item.muted = !this.item.muted
      }
      const timestamp = Date.now()
      this.$parent.$parent.$parent.stateChangeRequestInFlight.add(timestamp)
      this.$http.post('/api/sentinel/watchdog/' + (m < 1 ? 'un' : '') + 'mute/' + this.item.watchDogId,
        {
          minutes: m,
        }).then((response) => {
          this.$parent.$parent.$parent.stateChangeRequestInFlight.delete(timestamp)
          // TODO move item to muted, instead of message
          $(this.$el).find('.mutemenu').html('...').fadeIn(300)
          // trigger sotw refresh (TODO use "emit", nicer)
          this.$parent.$parent.$parent.stateOfTheWorld()
        }, (response) => {
          this.$parent.$parent.$parent.stateChangeRequestInFlight.delete(timestamp)
          // TODO additional error handling
          $(this.$el).find('.mutemenu').fadeIn(300)
        })
    },
    setIssueStatus: function (val) {
      // if we are not on the mute tab, do ring animation on the mute tab button
      // and fade out the item
      if (val === 3 && this.itemtype !== 'mute') {
        $(this.$el).fadeOut(600, () => {
          this.$emit('muteRingAni')
          this.$parent.$parent.$parent.setIssueStatus(this.item.watchDogId, val)
        })
      } else {
        this.$parent.$parent.$parent.setIssueStatus(this.item.watchDogId, val)
      }
    },
    showProductDetails: function () {
      if (this.item.productId !== null) {
        $(this.$el).popup('hide all')
        this.$parent.$parent.openProductDetailModal([this.item.productId], 0)
      }
    },
    getMarketplaceFlag: function (item) {
      if (!item || !item.marketplace) return 'flag'
      var marketplace = item.marketplace.toLowerCase()
      var isEU = item.productCollectionId && ['uk', 'de', 'fr', 'es', 'it'].indexOf(marketplace) > -1
      return (isEU ? 'eu' : marketplace.replace('uk', 'gb')) + ' flag'
    },
    getProductTitle: function (productId) {
      var products = this.$parent.$parent.$parent.worldStore.products
      if (!products) return '(Product data unavailable)'
      
      // Try direct productId lookup first
      if (productId && products[productId]) {
        return products[productId].productTitle || ''
      }
      
      // For reviews, try productGroupId lookup
      var item = this.item
      if (item && item.productGroupId) {
        // Check if productGroupId directly matches a product key
        if (products[item.productGroupId]) {
          return products[item.productGroupId].productTitle || ''
        }
        // Search products for matching productGroupId
        var productKeys = Object.keys(products)
        for (var i = 0; i < productKeys.length; i++) {
          var prod = products[productKeys[i]]
          if (prod && (prod.productGroupId === item.productGroupId || prod.id === item.productGroupId)) {
            return prod.productTitle || ''
          }
        }
      }
      
      // Return empty - the product may not be in the current products list
      return ''
    },
    prettyfyReviewText: function (t) {
      if (!t) return ''
      return t
        .replace(/;|(and)/gi, ' <small style=\'color:grey;\'>&nbsp;&nbsp;&amp;&nbsp;&nbsp;</small>')
        .replace(/(#\d+)/gi, '<span style=\'color:purple;\'>$1</span>')
        .replace(/(\d)-star/gi, '<span style=\'color:orange;\'>$1&#9733;</span>')
    },
    prettyfyRatingText: function (t) {
      if (!t) return ''
      return t
        .replace(/star rating is ([45][.0-9]*),?/gi, 'is <span style=\'color:orange;\'>$1&#9733;</span>')
        .replace(/star rating is ([123][.0-9]*),?/gi, 'is <span style=\'color:darkred;\'>$1&#9733;</span>')
        .replace(/(\d+) (rating|review)/gi, '<span style=\'color:purple;\'>$1</span> $2')
        .replace(/(review|rating) count is (\d+)/gi, ' <small style=\'color:grey;\'>&nbsp;&nbsp;&amp;&nbsp;&nbsp;</small> $1 count is <span style=\'color:purple;\'>$2</span>')
    },
    qqq: function (q) {
      window.alert(q)
    }
  },
  computed: {},
  mounted: function () {
    $(this.$el).find('.circular[data-content], .ui.dropdown span[data-html]').popup({ delay: { show: 0, hide: 0 }, transition: 'fade' })
    $(this.$el).find('.ui.dropdown').dropdown({action: 'hide'})
    // Intersection Observer for lazy loading
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this.imageLoaded = true
          observer.disconnect()
        }
      }, { threshold: 0.1 })
      observer.observe(this.$el)
    } else {
      this.imageLoaded = true
    }
  },
  watch: {},
}
</script>

<style>
#wdCont .list>.item {padding: 5px 4px; position: relative;}
#wdCont .list .item:hover {background-color: #eee; border-radius: 4px; }
#wdCont .list .item       img {display:inline-block; width:auto; height:110px; }

#wdCont .list .item .ui.attached.label .detail {transition: 0.3s; font-size: 0; margin-left: 0;}
#wdCont .list .item .ui.attached.label:hover .detail {font-size: inherit; margin-left: 1em;}

#wdCont .list .item .content {width: 100%;}
#wdCont .list .item .content .header {margin-bottom: 5px;}

#wdCont .item .issueStatusButton {visibility: hidden;}
#wdCont .item:hover .issueStatusButton {visibility: visible;}
#wdCont .issueStatusButton .ui.button {padding-right:7px;margin-right:-2px; background-color: #fff !important;}
#wdCont .issueStatusButton .ui.dropdown.button {padding:7px 8px 3px 8px;}
#wdCont .issueStatusButton .ui.pointing.dropdown>.menu {top: 18px;}
#wdCont .issueStatusButton .ui.pointing.dropdown>.menu .item{font-size: 11px;}
</style>



// WEBPACK FOOTER //
// WatchdogItem.vue?0a1cc5dd